module.exports = __webpack_public_path__ + "img/doc.976a1842.svg";